import { render, staticRenderFns } from "./NeedCommon.vue?vue&type=template&id=b4b2440e&scoped=true&"
import script from "./NeedCommon.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedCommon.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b2440e",
  null
  
)

export default component.exports